import { HttpClient } from "services/HttpClient";
import { Clinician } from "types/Clinician";
import { getData, getRoleData } from "../contexts/authContext";
import * as cognito from "../libs/cognito";

export class AuthRepository extends HttpClient {
  public getMe = async (): Promise<Clinician> => {
    const token = await getData("idToken");
    const { data } = await this.instance.get(`/clinician/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    data.role = await getRoleData();
    return data;
  };

  public deleteClinician = async (email: string, isPatient: boolean) => {
    const token = await getData("idToken");
    const { data } = await this.instance.delete(
      `/clinician/email/${email}/type/${
        isPatient ? "patient" : "clinician"
      }/delete`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  };

  public disableAthlete = async (id: string) => {
    const token = await getData("idToken");
    const { data } = await this.instance.patch(
      `/patient/${id}/disable`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  };

  public enableAthlete = async (id: string) => {
    const token = await getData("idToken");
    const { data } = await this.instance.patch(
      `/patient/${id}/enable`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  };

  constructor() {
    super(process.env.REACT_APP_BASE_URL as string, () => {
      cognito.signOut(true);
    });
  }

  private static classInstance?: AuthRepository;

  public static getInstance() {
    if (!this.classInstance) {
      this.classInstance = new AuthRepository();
    }
    return this.classInstance;
  }
}
